const { elements } = require('../variables');
const { installmentsNotAvailable } = require('../html');

/**
 * Generic handler for BNPL (Buy Now Pay Later) flex payment methods
 * Supports: Tamara, Tabby, Taly
 *
 * @param {Object} Selector - Selector instance for DOM operations
 * @param {Object} documentCheckout - Shadow DOM checkout element
 * @param {Object} configs - Payment method configuration
 * @param {Object} options - Method-specific options
 * @param {Function} [options.onInit] - Method-specific initialization function
 * @param {Function} [options.checkAvailability] - Function to check if method is available
 * @param {Function} [options.getLabel] - Function to get method label
 * @param {Function} options.getWidget - Function to generate widget HTML
 * @returns {Promise|undefined} Promise that resolves when payment options are loaded
 */
const handleFlexPaymentMethod = (Selector, documentCheckout, configs, options = {}) => {
  if (!configs) return Promise.resolve();

  const { flow, icon, code, pre_payment_check_url, pre_payment_options_available } = configs;

  // Handle method-specific initialization
  if (options.onInit) {
    options.onInit(configs);
  }

  if (!pre_payment_options_available) {
    return Selector.getinstallmentsOptions(pre_payment_check_url, code)
      .then((pre_payment_options) => {
        const methodBlock = documentCheckout.querySelector(`[data-method-id="id_${flow}"]`);

        // Check availability based on method-specific logic
        const isAvailable = options.checkAvailability
          ? options.checkAvailability(pre_payment_options)
          : pre_payment_options?.is_available;

        if (isAvailable) {
          const methodLabel = options.getLabel
            ? options.getLabel(pre_payment_options)
            : '';
          methodBlock.innerHTML = options.getWidget(methodLabel, configs);
          methodBlock.classList.add(elements.accordionItem);
          methodBlock.classList.remove(elements.disabled, elements.loadingInstallmentsOptionsBlock);
        } else {
          methodBlock.innerHTML = installmentsNotAvailable(icon, flow);
          methodBlock.classList.remove(elements.accordionItem, elements.paymentMethod, elements.loadingInstallmentsOptionsBlock);
        }
      });
  }

  return Promise.resolve();
};

exports.handleFlexPaymentMethod = handleFlexPaymentMethod;
